import React from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";

import { useRef, useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";

import "../styles/Faq.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndustry,
  faChartLine,
  faCogs,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import { FaqSection } from "./FaqSection";
//import { FaqSection } from './FaqSection';
import "../styles/Aerospace.css";
import ModalFunction from "./Modal";
import TabTitle from "../components/TabTitle";
import DataSources from "../components/DataSources";

const logo = "/img/headerlogo.png";
const kpi = "/img/KPI-DASH 2.png";

function Manufacturing() {
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);
  const [modalShow, setModalShow] = React.useState(false);

  // Close dropdown when clicking outside the navbar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div>
      <LandingSection
        data={{ imageName: "manufacturing.webp", title: "Utah Manufacturing" }}
      />
      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>A hub of innovation and growth.</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah’s manufacturing sector is a cornerstone of its economy,
              fostering growth and creating numerous employment opportunities.
              Spanning diverse industries such as aerospace manufacturing,
              technology hardware production, and traditional sectors like
              textiles and food processing, Utah’s manufacturing landscape is
              both dynamic and diverse. Dive into our comprehensive reports and
              insights to uncover how manufacturing is propelling innovation and
              shaping the future of economic development in Utah.
            </p>
          </div>
        </div>
      </div>
      <TabTitle />
      <FaqSection />
      <DataSources
        sources={[
          "https://ledextract.ces.census.gov/qwi/all",
          "https://blackwealthdata.org/explore/business",
          "https://utah-mep.org/manufacturing-data/",
          "https://tradingeconomics.com/united-states/manufacturing-employment-in-utah-thous-of-persons-m-sa-fed-data.html",
          "https://apps.bea.gov/industry/factsheet/factsheet.html#31G",
        ]}
      />
      <Footer />
    </div>
  );
}

export default Manufacturing;
